import { render, staticRenderFns } from "./ProdutosMenosVendidos.vue?vue&type=template&id=1b57b70c&"
import script from "./ProdutosMenosVendidos.vue?vue&type=script&lang=js&"
export * from "./ProdutosMenosVendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b57b70c')) {
      api.createRecord('1b57b70c', component.options)
    } else {
      api.reload('1b57b70c', component.options)
    }
    module.hot.accept("./ProdutosMenosVendidos.vue?vue&type=template&id=1b57b70c&", function () {
      api.rerender('1b57b70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProdutosMenosVendidos.vue"
export default component.exports